import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Material
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// Components
import Input from '../../../../components/inputs/input';

const EditDetailModal = ({ detail, onSave, onClose, open }) => {
    const [observation, setObservation] = useState(detail.observation);
    const [quantity, setQuantity] = useState(detail.quantity);

    const handleSave = () => {
        onSave(detail.refId, { ...detail, observation, quantity });
        onClose();
    }

    const handleNumberChange = (event) => {
        const num = Number.parseInt(event.target.value);
        
        if (!isNaN(num) && num >= 0)
            setQuantity(num);
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {`Detalle ${detail.refId}`}
            </DialogTitle>
            <DialogContent dividers style={{ minWidth: 430 }}>
                <Grid container spacing={1}>
                    <Grid size={12}>
                        <Input
                            fullWidth
                            name='quantity'
                            label='Cantidad'
                            onChange={handleNumberChange}
                            value={quantity}
                            type='number'
                        />
                    </Grid>
                    <Grid size={12}>
                        <Input
                            fullWidth
                            multiline
                            rows={5}
                            size='small'
                            name='observation'
                            label='Observacion'
                            onChange={(e) => setObservation(e.target.value)}
                            value={observation}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                >
                    Cancelar
                </Button>
                <Button
                    onClick={handleSave}
                    color="primary"
                    variant='outlined'
                    autoFocus
                >
                    Guardar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

EditDetailModal.defaultProps = {
    onSave: () => { },
    onClose: () => { }
}

EditDetailModal.prototype = {
    onSave: PropTypes.func,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    detail: PropTypes.object
}

export default EditDetailModal;